import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {DatatableService} from '../../datatable.service';
import {Model} from '@common/core/types/models/model';

@Component({
    selector: 'datatable-header-search-input',
    templateUrl: './datatable-header-search-input.component.html',
    styleUrls: ['./datatable-header-search-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatatableHeaderSearchInputComponent implements OnInit {
    public searchControl = new FormControl();
    @Input() placeholder: string;
    @Input() hideIcon = false;

    constructor(public datatable: DatatableService<Model>) {}

    ngOnInit() {
        this.searchControl.valueChanges
            .pipe(debounceTime(400), distinctUntilChanged())
            .subscribe(query => {
                this.datatable.filters$.next({
                    ...this.datatable.filters$.value,
                    query
                });
            });
    }
}
